import router from '@/main/router'

export default router
